import React from "react";
import { Link } from "react-router-dom";


const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const CtaSection = (props) => {
    return (
        <section className="wpo-cta-section mt-lg-4">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-8 col-md-6 col-12 ">
                        <div className="wpo-cta-text">
                            <span>
                                Our company offers fast delivery services.</span>
                            <p>
                                We understand how important it is to receive and send cargo on time, so we have developed special offers for express delivery. Regardless of the distance and complexity of the route,
                                we guarantee the shortest delivery times without compromising safety and quality
                                Our logisticians carefully plan each stage of transportation, using optimal routes and modern tracking technologies to ensure that your cargo is delivered on time.
                            </p>
                        </div>
                    </div>
                    {/* <div className="col-lg-4 col-md-6 col-12">
                        <div className="wpo-cta-btn">
                            <Link onClick={ClickHandler} className="theme-btn-s2" to="/contact">JOIN WITH US</Link>
                        </div>
                    </div> */}
                </div>
            </div>
        </section>
    )
}
export default CtaSection;


